import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const types = {
  SET_QRCODE_CURRENT: 'SET_QRCODE_CURRENT',
  SET_QRCODE_GROUPS: 'SET_QRCODE_GROUPS',
  SET_QRCODE_SELECTED: 'SET_QRCODE_SELECTED',
  SET_QRCODE_DETALHE: 'SET_QRCODE_DETALHE',
  SET_QRCODE_COMPRADOS: 'SET_QRCODE_COMPRADOS',
  MODAL_ALERT: 'MODAL_ALERT'
}

export default new Vuex.Store({
  state: {
    loading: false,
    user: null,
    access_token: null,
    refresh_token: null,
    modal_alert: null,
    qrcode_current: null,
    qrcode_groups: [],
    qrcode_selected: [],
    qrcode_comprados: [],
    qrcode_detalhe: null,
  },
  mutations: {
    auth_request(state) {
      console.log('mutations.auth_request');
      state.loading = true;
    },
    auth_success(state, { user, access_token, refresh_token }) {
      console.log('mutations.auth_success');
      state = {
        ...state,
        user,
        loading: false,
        access_token,
        refresh_token
      }
    },
    auth_error(state) {
      console.log('mutations.auth_error');
      state.loading = false;
    },
    auth_logout(state) {
      console.log('mutations.auth_logout');
      state.loading = false;
      state = {
        ...state,
        user: null,
        access_token: null,
        refresh_token: null
      }
    },
    [types.MODAL_ALERT] (state, payload) {
      console.log(types.MODAL_ALERT, payload);
      state.modal_alert = payload;
    },
    [types.SET_QRCODE_CURRENT] (state, payload) {
      console.log(types.SET_QRCODE_CURRENT, payload);
      state.qrcode_current = payload;
    },
    [types.SET_QRCODE_GROUPS] (state, payload) {
      console.log(types.SET_QRCODE_GROUPS, payload);
      state.qrcode_groups = payload;
    },
    [types.SET_QRCODE_SELECTED] (state, payload) {
      console.log(types.SET_QRCODE_SELECTED, payload);
      state.qrcode_selected = payload;
    },
    [types.SET_QRCODE_COMPRADOS] (state, payload) {
      console.log(types.SET_QRCODE_COMPRADOS, payload);
      state.qrcode_comprados = payload;
    },
    [types.SET_QRCODE_DETALHE] (state, payload) {
      console.log(types.SET_QRCODE_DETALHE, payload);
      state.qrcode_detalhe = payload;
    },
  },
  actions: {
    [types.SET_QRCODE_CURRENT] ({ commit }, payload) {
      commit(types.SET_QRCODE_CURRENT, payload);
    },
    [types.SET_QRCODE_GROUPS] ({ commit }, payload) {
      commit(types.SET_QRCODE_GROUPS, payload);
    },
    [types.SET_QRCODE_SELECTED] ({ commit }, payload) {
      commit(types.SET_QRCODE_SELECTED, payload);
    },
    [types.SET_QRCODE_COMPRADOS] ({ commit }, payload) {
      commit(types.SET_QRCODE_COMPRADOS, payload);
    },
    [types.SET_QRCODE_DETALHE] ({ commit }, payload) {
      commit(types.SET_QRCODE_DETALHE, payload);
    },
    [types.MODAL_ALERT] ({ commit }, payload) {
      commit(types.MODAL_ALERT, payload);
    },
  },
})
